export enum InfoRequestTypeEnum {
  InfoRequest = 1,
  ThirdParty = 2,
  Garnishment = 3
}
export enum InfoRequestSubtypeEnum {
  Documents = 1,
  DepoTrial = 2
}
export enum InfoRequestStatusEnum {
  Resolved = 1,
  AdminReview = 2,
  DeliveryPrep = 3,
  LegalReview = 4,
  InPortal = 5
}
export enum InfoRequestStatusGroup {
  Prep = 1,
  Legal = 2,
  Delivery = 3,
  Portal = 4,
  Closed = 5
}

export enum ReduxFormId {
  TeamEdit = 'team-edit',
  CoGeneralSettingsEdit = 'co-general-settings-edit',
  CoEntityEdit = 'co-entity-edit',
  CoRegisteredAgentSettings = 'co-registered-agent-settings',
  CoUserEdit = 'co-user-edit',
  MatterCreate = 'matter-create-form',
  MatterEdit = 'info-request-edit-form',
  MatterAccessEdit = 'info-request-access-edit-form',
  SubtypeEdit = 'subtype-edit-form',
  InvoiceTemplateEdit = 'invoice-template-edit-form',
  ReportEdit = 'report-edit-form',
  CorrespondenceEdit = 'correspondence-edit',
  LibraryTemplateEdit = 'library-template-edit-form',
  LibraryDocumentEdit = 'library-document-edit-form',
  CustomPicklistConfigEdit = 'custom-picklist-config-edit-form',
  MatterNoteEdit = 'info-request-note-edit-form',
  CompanyEntityEdit = 'company-entity-edit',
  MatterListConfigEdit = 'matter-list-config-edit-form',
  DatePickerConfigEdit = 'date-picker-config-edit-form',
  ServingPartyEdit = 'serving-party-edit',
  SubfolderGroupEdit = 'subfolder-group-edit',
  UpdateOrCreateFolder = 'update-or-create-folder-edit-form',
  DataExportReport = 'data-export-report-form',
  ServeportPortalEdit = 'serveport-portal-edit-form',
  DocumentTransferNewDialogEdit = 'document-transfer-new-dialog-form',
  AnswerEdit = 'matter-answer-edit-form'
}
export enum ReduxListId {
  TeamList = 'team-list',
  CoInboundEmailSettingsList = 'co-inbound-email-settings-list',
  CoRegisteredAgentMappingsList = 'co-registered-agent-mappings-list',
  CoEntityList = 'co-entity-list',
  CoUserList = 'co-user-list',
  LibraryTemplateList = 'library-template-list',
  CustomPicklistConfigList = 'custom-picklist-config-list',
  DocumentList = 'document-list',
  DocumentParticipantList = 'document-participant-list',
  SubtypeList = 'subtype-list',
  InvoiceTemplateList = 'invoice-template-list',
  DocumentAlertList = 'document-alert-list',
  DocumentFileList = 'document-file-list',
  PreconfiguredReportsList = 'preconfigured-reports-list',
  DocumentNoteList = 'document-note-list',
  CompanyEntityList = 'company-entity-list',
  DocumentLinkList = 'document-link-list',
  MatterSubtypeUsersList = 'matter-subtype-users-list',
  ServingPartyList = 'serving-party-list',
  SubfolderGroupList = 'subfolder-group-list',
  ServeportPortalsList = 'serveport-portals-list',
  SubjectSearchList = 'document-subject-search-list',
  TransferList = 'document-transfer-list'
}
export enum ReduxComponentId {
  FileUpload = 'file-upload'
}
export enum ReduxDialogId {
  InvoicePreviewDialog = 'sl-lpms-invoice-template-edit-html-dialog',
  CompanyEntityFileTransferDialog = 'company-entity-file-transfer-dialog',
  LibraryDocumentFileTransferDialog = 'library-document-file-transfer-dialog',
  CompanySettingsFileTransferDialog = 'company-settings-file-transfer-dialog',
  UserSettingsFileTransferDialog = 'user-settings-file-transfer-dialog'
}

export enum ReviewerFilter {
  All = 0,
  AssignedToMe = 1,
  Unassigned = 2
}
